import * as tslib_1 from "tslib";
import { Attr, Value, Record, Text, Form, Uri } from '@swim/recon';
var Envelope = (function () {
    function Envelope() {
    }
    Object.defineProperty(Envelope.prototype, "tag", {
        get: function () {
            return this.constructor.tag;
        },
        enumerable: true,
        configurable: true
    });
    Envelope.prototype.prio = function (prio) {
        if (prio === undefined) {
            return 0;
        }
        else {
            return this;
        }
    };
    Envelope.prototype.rate = function (rate) {
        if (rate === undefined) {
            return 0;
        }
        else {
            return this;
        }
    };
    Envelope.prototype.toRecon = function () {
        return this.toValue().toRecon();
    };
    Object.defineProperty(Envelope, "tag", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Envelope.fromValue = function (value) {
        switch (value.tag) {
            case 'event': return EventMessage.fromValue(value);
            case 'command': return CommandMessage.fromValue(value);
            case 'link': return LinkRequest.fromValue(value);
            case 'linked': return LinkedResponse.fromValue(value);
            case 'sync': return SyncRequest.fromValue(value);
            case 'synced': return SyncedResponse.fromValue(value);
            case 'unlink': return UnlinkRequest.fromValue(value);
            case 'unlinked': return UnlinkedResponse.fromValue(value);
            case 'auth': return AuthRequest.fromValue(value);
            case 'authed': return AuthedResponse.fromValue(value);
            case 'deauth': return DeauthRequest.fromValue(value);
            case 'deauthed': return DeauthedResponse.fromValue(value);
            default: return undefined;
        }
    };
    Envelope.parseRecon = function (input) {
        return Envelope.fromValue(Value.parseRecon(input));
    };
    return Envelope;
}());
export { Envelope };
var HostEnvelope = (function (_super) {
    tslib_1.__extends(HostEnvelope, _super);
    function HostEnvelope(body) {
        var _this = _super.call(this) || this;
        _this._body = body;
        return _this;
    }
    HostEnvelope.prototype.node = function (node) {
        if (node === undefined) {
            return Uri.Empty;
        }
        else {
            return this;
        }
    };
    HostEnvelope.prototype.lane = function (lane) {
        if (lane === undefined) {
            return Uri.Empty;
        }
        else {
            return this;
        }
    };
    HostEnvelope.prototype.body = function (body) {
        if (body === undefined) {
            return this._body;
        }
        else {
            body = Value.fromAny(body);
            return this.copy(body);
        }
    };
    HostEnvelope.prototype.toValue = function () {
        return Attr.of(this.tag).concat(this._body);
    };
    HostEnvelope.fromValue = function (value, E) {
        var header = value.header(E.tag);
        if (header.isDefined()) {
            var body = value.body();
            return new E(body);
        }
        return undefined;
    };
    return HostEnvelope;
}(Envelope));
export { HostEnvelope };
var LaneEnvelope = (function (_super) {
    tslib_1.__extends(LaneEnvelope, _super);
    function LaneEnvelope(node, lane, body) {
        var _this = _super.call(this) || this;
        _this._node = node;
        _this._lane = lane;
        _this._body = body;
        return _this;
    }
    LaneEnvelope.prototype.node = function (node) {
        if (node === undefined) {
            return this._node;
        }
        else {
            node = Uri.fromAny(node);
            return this.copy(node, this._lane, this._body);
        }
    };
    LaneEnvelope.prototype.lane = function (lane) {
        if (lane === undefined) {
            return this._lane;
        }
        else {
            lane = Uri.fromAny(lane);
            return this.copy(this._node, lane, this._body);
        }
    };
    LaneEnvelope.prototype.body = function (body) {
        if (body === undefined) {
            return this._body;
        }
        else {
            body = Value.fromAny(body);
            return this.copy(this._node, this._lane, body);
        }
    };
    LaneEnvelope.prototype.toValue = function () {
        var header = Record.empty(2)
            .slot('node', this._node.toUri())
            .slot('lane', this._lane.toUri());
        return Attr.of(this.tag, header).concat(this._body);
    };
    LaneEnvelope.fromValue = function (value, E) {
        var node;
        var lane;
        var header = value.header(E.tag);
        header.forEach(function (item, index) {
            if (item.key instanceof Text) {
                var key = item.key.value;
                if (key === 'node') {
                    node = item.cast(Form.Uri, node);
                }
                else if (key === 'lane') {
                    lane = item.cast(Form.Uri, lane);
                }
            }
            else if (item instanceof Value) {
                if (index === 0) {
                    node = item.cast(Form.Uri, node);
                }
                else if (index === 1) {
                    lane = item.cast(Form.Uri, lane);
                }
            }
        }, this);
        if (node && lane) {
            var body = value.body();
            return new E(node, lane, body);
        }
        return undefined;
    };
    return LaneEnvelope;
}(Envelope));
export { LaneEnvelope };
var LinkEnvelope = (function (_super) {
    tslib_1.__extends(LinkEnvelope, _super);
    function LinkEnvelope(node, lane, prio, rate, body) {
        var _this = _super.call(this) || this;
        _this._node = node;
        _this._lane = lane;
        _this._prio = prio;
        _this._rate = rate;
        _this._body = body;
        return _this;
    }
    LinkEnvelope.prototype.node = function (node) {
        if (node === undefined) {
            return this._node;
        }
        else {
            node = Uri.fromAny(node);
            return this.copy(node, this._lane, this._prio, this._rate, this._body);
        }
    };
    LinkEnvelope.prototype.lane = function (lane) {
        if (lane === undefined) {
            return this._lane;
        }
        else {
            lane = Uri.fromAny(lane);
            return this.copy(this._node, lane, this._prio, this._rate, this._body);
        }
    };
    LinkEnvelope.prototype.prio = function (prio) {
        if (prio === undefined) {
            return this._prio;
        }
        else {
            return this.copy(this._node, this._lane, prio, this._rate, this._body);
        }
    };
    LinkEnvelope.prototype.rate = function (rate) {
        if (rate === undefined) {
            return this._rate;
        }
        else {
            return this.copy(this._node, this._lane, this._prio, rate, this._body);
        }
    };
    LinkEnvelope.prototype.body = function (body) {
        if (body === undefined) {
            return this._body;
        }
        else {
            body = Value.fromAny(body);
            return this.copy(this._node, this._lane, this._prio, this._rate, body);
        }
    };
    LinkEnvelope.prototype.toValue = function () {
        var header = Record.empty(4)
            .slot('node', this._node.toUri())
            .slot('lane', this._lane.toUri());
        if (this._prio) {
            header.slot('prio', this._prio);
        }
        if (this._rate) {
            header.slot('rate', this._rate);
        }
        return Attr.of(this.tag, header).concat(this._body);
    };
    LinkEnvelope.fromValue = function (value, E) {
        var node;
        var lane;
        var prio = 0;
        var rate = 0;
        var header = value.header(E.tag);
        header.forEach(function (item, index) {
            if (item.key instanceof Text) {
                var key = item.key.value;
                if (key === 'node') {
                    node = item.cast(Form.Uri, node);
                }
                else if (key === 'lane') {
                    lane = item.cast(Form.Uri, lane);
                }
                else if (key === 'prio') {
                    prio = item.numberValue(prio);
                }
                else if (key === 'rate') {
                    rate = item.numberValue(rate);
                }
            }
            else if (item instanceof Value) {
                if (index === 0) {
                    node = item.cast(Form.Uri, node);
                }
                else if (index === 1) {
                    lane = item.cast(Form.Uri, lane);
                }
            }
        }, this);
        if (node && lane) {
            var body = value.body();
            return new E(node, lane, prio, rate, body);
        }
        return undefined;
    };
    return LinkEnvelope;
}(Envelope));
export { LinkEnvelope };
var EventMessage = (function (_super) {
    tslib_1.__extends(EventMessage, _super);
    function EventMessage(node, lane, body) {
        return _super.call(this, node, lane, body) || this;
    }
    EventMessage.prototype.copy = function (node, lane, body) {
        return new EventMessage(node, lane, body);
    };
    EventMessage.fromValue = function (value) {
        return LaneEnvelope.fromValue(value, EventMessage);
    };
    Object.defineProperty(EventMessage, "tag", {
        get: function () {
            return 'event';
        },
        enumerable: true,
        configurable: true
    });
    EventMessage.of = function (node, lane, body) {
        if (body === void 0) { body = Value.Absent; }
        node = Uri.fromAny(node);
        lane = Uri.fromAny(lane);
        body = Value.fromAny(body);
        return new EventMessage(node, lane, body);
    };
    return EventMessage;
}(LaneEnvelope));
export { EventMessage };
var CommandMessage = (function (_super) {
    tslib_1.__extends(CommandMessage, _super);
    function CommandMessage(node, lane, body) {
        return _super.call(this, node, lane, body) || this;
    }
    CommandMessage.prototype.copy = function (node, lane, body) {
        return new CommandMessage(node, lane, body);
    };
    CommandMessage.fromValue = function (value) {
        return LaneEnvelope.fromValue(value, CommandMessage);
    };
    Object.defineProperty(CommandMessage, "tag", {
        get: function () {
            return 'command';
        },
        enumerable: true,
        configurable: true
    });
    CommandMessage.of = function (node, lane, body) {
        if (body === void 0) { body = Value.Absent; }
        node = Uri.fromAny(node);
        lane = Uri.fromAny(lane);
        body = Value.fromAny(body);
        return new CommandMessage(node, lane, body);
    };
    return CommandMessage;
}(LaneEnvelope));
export { CommandMessage };
var LinkRequest = (function (_super) {
    tslib_1.__extends(LinkRequest, _super);
    function LinkRequest(node, lane, prio, rate, body) {
        return _super.call(this, node, lane, prio, rate, body) || this;
    }
    LinkRequest.prototype.copy = function (node, lane, prio, rate, body) {
        return new LinkRequest(node, lane, prio, rate, body);
    };
    LinkRequest.fromValue = function (value) {
        return LinkEnvelope.fromValue(value, LinkRequest);
    };
    Object.defineProperty(LinkRequest, "tag", {
        get: function () {
            return 'link';
        },
        enumerable: true,
        configurable: true
    });
    LinkRequest.of = function (node, lane, prio, rate, body) {
        if (prio === void 0) { prio = 0; }
        if (rate === void 0) { rate = 0; }
        if (body === void 0) { body = Value.Absent; }
        node = Uri.fromAny(node);
        lane = Uri.fromAny(lane);
        body = Value.fromAny(body);
        return new LinkRequest(node, lane, prio, rate, body);
    };
    return LinkRequest;
}(LinkEnvelope));
export { LinkRequest };
var LinkedResponse = (function (_super) {
    tslib_1.__extends(LinkedResponse, _super);
    function LinkedResponse(node, lane, prio, rate, body) {
        return _super.call(this, node, lane, prio, rate, body) || this;
    }
    LinkedResponse.prototype.copy = function (node, lane, prio, rate, body) {
        return new LinkedResponse(node, lane, prio, rate, body);
    };
    LinkedResponse.fromValue = function (value) {
        return LinkEnvelope.fromValue(value, LinkedResponse);
    };
    Object.defineProperty(LinkedResponse, "tag", {
        get: function () {
            return 'linked';
        },
        enumerable: true,
        configurable: true
    });
    LinkedResponse.of = function (node, lane, prio, rate, body) {
        if (prio === void 0) { prio = 0; }
        if (rate === void 0) { rate = 0; }
        if (body === void 0) { body = Value.Absent; }
        node = Uri.fromAny(node);
        lane = Uri.fromAny(lane);
        body = Value.fromAny(body);
        return new LinkedResponse(node, lane, prio, rate, body);
    };
    return LinkedResponse;
}(LinkEnvelope));
export { LinkedResponse };
var SyncRequest = (function (_super) {
    tslib_1.__extends(SyncRequest, _super);
    function SyncRequest(node, lane, prio, rate, body) {
        return _super.call(this, node, lane, prio, rate, body) || this;
    }
    SyncRequest.prototype.copy = function (node, lane, prio, rate, body) {
        return new SyncRequest(node, lane, prio, rate, body);
    };
    SyncRequest.fromValue = function (value) {
        return LinkEnvelope.fromValue(value, SyncRequest);
    };
    Object.defineProperty(SyncRequest, "tag", {
        get: function () {
            return 'sync';
        },
        enumerable: true,
        configurable: true
    });
    SyncRequest.of = function (node, lane, prio, rate, body) {
        if (prio === void 0) { prio = 0; }
        if (rate === void 0) { rate = 0; }
        if (body === void 0) { body = Value.Absent; }
        node = Uri.fromAny(node);
        lane = Uri.fromAny(lane);
        body = Value.fromAny(body);
        return new SyncRequest(node, lane, prio, rate, body);
    };
    return SyncRequest;
}(LinkEnvelope));
export { SyncRequest };
var SyncedResponse = (function (_super) {
    tslib_1.__extends(SyncedResponse, _super);
    function SyncedResponse(node, lane, body) {
        return _super.call(this, node, lane, body) || this;
    }
    SyncedResponse.prototype.copy = function (node, lane, body) {
        return new SyncedResponse(node, lane, body);
    };
    SyncedResponse.fromValue = function (value) {
        return LaneEnvelope.fromValue(value, SyncedResponse);
    };
    Object.defineProperty(SyncedResponse, "tag", {
        get: function () {
            return 'synced';
        },
        enumerable: true,
        configurable: true
    });
    SyncedResponse.of = function (node, lane, body) {
        if (body === void 0) { body = Value.Absent; }
        node = Uri.fromAny(node);
        lane = Uri.fromAny(lane);
        body = Value.fromAny(body);
        return new SyncedResponse(node, lane, body);
    };
    return SyncedResponse;
}(LaneEnvelope));
export { SyncedResponse };
var UnlinkRequest = (function (_super) {
    tslib_1.__extends(UnlinkRequest, _super);
    function UnlinkRequest(node, lane, body) {
        return _super.call(this, node, lane, body) || this;
    }
    UnlinkRequest.prototype.copy = function (node, lane, body) {
        return new UnlinkRequest(node, lane, body);
    };
    UnlinkRequest.fromValue = function (value) {
        return LaneEnvelope.fromValue(value, UnlinkRequest);
    };
    Object.defineProperty(UnlinkRequest, "tag", {
        get: function () {
            return 'unlink';
        },
        enumerable: true,
        configurable: true
    });
    UnlinkRequest.of = function (node, lane, body) {
        if (body === void 0) { body = Value.Absent; }
        node = Uri.fromAny(node);
        lane = Uri.fromAny(lane);
        body = Value.fromAny(body);
        return new UnlinkRequest(node, lane, body);
    };
    return UnlinkRequest;
}(LaneEnvelope));
export { UnlinkRequest };
var UnlinkedResponse = (function (_super) {
    tslib_1.__extends(UnlinkedResponse, _super);
    function UnlinkedResponse(node, lane, body) {
        return _super.call(this, node, lane, body) || this;
    }
    UnlinkedResponse.prototype.copy = function (node, lane, body) {
        return new UnlinkedResponse(node, lane, body);
    };
    UnlinkedResponse.fromValue = function (value) {
        return LaneEnvelope.fromValue(value, UnlinkedResponse);
    };
    Object.defineProperty(UnlinkedResponse, "tag", {
        get: function () {
            return 'unlinked';
        },
        enumerable: true,
        configurable: true
    });
    UnlinkedResponse.of = function (node, lane, body) {
        if (body === void 0) { body = Value.Absent; }
        node = Uri.fromAny(node);
        lane = Uri.fromAny(lane);
        body = Value.fromAny(body);
        return new UnlinkedResponse(node, lane, body);
    };
    return UnlinkedResponse;
}(LaneEnvelope));
export { UnlinkedResponse };
var AuthRequest = (function (_super) {
    tslib_1.__extends(AuthRequest, _super);
    function AuthRequest(body) {
        return _super.call(this, body) || this;
    }
    AuthRequest.prototype.copy = function (body) {
        return new AuthRequest(body);
    };
    AuthRequest.fromValue = function (value) {
        return HostEnvelope.fromValue(value, AuthRequest);
    };
    Object.defineProperty(AuthRequest, "tag", {
        get: function () {
            return 'auth';
        },
        enumerable: true,
        configurable: true
    });
    AuthRequest.of = function (body) {
        if (body === void 0) { body = Value.Absent; }
        body = Value.fromAny(body);
        return new AuthRequest(body);
    };
    return AuthRequest;
}(HostEnvelope));
export { AuthRequest };
var AuthedResponse = (function (_super) {
    tslib_1.__extends(AuthedResponse, _super);
    function AuthedResponse(body) {
        return _super.call(this, body) || this;
    }
    AuthedResponse.prototype.copy = function (body) {
        return new AuthedResponse(body);
    };
    AuthedResponse.fromValue = function (value) {
        return HostEnvelope.fromValue(value, AuthedResponse);
    };
    Object.defineProperty(AuthedResponse, "tag", {
        get: function () {
            return 'authed';
        },
        enumerable: true,
        configurable: true
    });
    AuthedResponse.of = function (body) {
        if (body === void 0) { body = Value.Absent; }
        body = Value.fromAny(body);
        return new AuthedResponse(body);
    };
    return AuthedResponse;
}(HostEnvelope));
export { AuthedResponse };
var DeauthRequest = (function (_super) {
    tslib_1.__extends(DeauthRequest, _super);
    function DeauthRequest(body) {
        return _super.call(this, body) || this;
    }
    DeauthRequest.prototype.copy = function (body) {
        return new DeauthRequest(body);
    };
    DeauthRequest.fromValue = function (value) {
        return HostEnvelope.fromValue(value, DeauthRequest);
    };
    Object.defineProperty(DeauthRequest, "tag", {
        get: function () {
            return 'deauth';
        },
        enumerable: true,
        configurable: true
    });
    DeauthRequest.of = function (body) {
        if (body === void 0) { body = Value.Absent; }
        body = Value.fromAny(body);
        return new DeauthRequest(body);
    };
    return DeauthRequest;
}(HostEnvelope));
export { DeauthRequest };
var DeauthedResponse = (function (_super) {
    tslib_1.__extends(DeauthedResponse, _super);
    function DeauthedResponse(body) {
        return _super.call(this, body) || this;
    }
    DeauthedResponse.prototype.copy = function (body) {
        return new DeauthedResponse(body);
    };
    DeauthedResponse.fromValue = function (value) {
        return HostEnvelope.fromValue(value, DeauthedResponse);
    };
    Object.defineProperty(DeauthedResponse, "tag", {
        get: function () {
            return 'deauthed';
        },
        enumerable: true,
        configurable: true
    });
    DeauthedResponse.of = function (body) {
        if (body === void 0) { body = Value.Absent; }
        body = Value.fromAny(body);
        return new DeauthedResponse(body);
    };
    return DeauthedResponse;
}(HostEnvelope));
export { DeauthedResponse };
//# sourceMappingURL=data:application/json;base64,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